import * as loginActions from "./Store";
import AutenticacaoService from "../../services/AutenticacaoService";
import EmpresaService from "../../services/EmpresaService";
import "moment/locale/pt-br";
import {
  HELP_MYPARDINI,
  ORIGENS_INTEGRACAO,
  chaveArmazenamentoToken,
  chaveArmazenamentoIdSessao,
  chaveArmazenamentoSessaoNaoRenovada
} from "../../shared/utils/Constantes";
import moment from "moment";

let ultimoTimeout = 1;

const limparDadosAcessoEStorage = dispatch => {
  localStorage.removeItem(chaveArmazenamentoIdSessao);
  localStorage.removeItem(chaveArmazenamentoToken);
  localStorage.removeItem(chaveArmazenamentoSessaoNaoRenovada);
  dispatch(loginActions.limparDadosAcesso());
};

const inserirDadosUsuario = (dadosAcesso, idSessao, dispatch) => {
  dispatch(
    loginActions.inserirDadosAcesso({
      ...dadosAcesso.usuario,
      expiracaoTokenEmMinutos: dadosAcesso.expiracaoTokenEmMinutos,
      administrador: dadosAcesso.administrador,
      perfilUsuario: dadosAcesso.perfilUsuario
    })
  );
  dispatch(dispararTempoExpiracao(dadosAcesso.dataExpiracao, idSessao, dadosAcesso.tokenJwt));
};

const trocarEmpresaUsuario = (dadosAcesso, idSessao, empresaSelecionada, dispatch) => {
  dispatch(
    loginActions.trocarEmpresa({
      ...dadosAcesso.usuario,
      expiracaoTokenEmMinutos: dadosAcesso.expiracaoTokenEmMinutos,
      administrador: dadosAcesso.administrador,
      perfilUsuario: dadosAcesso.perfilUsuario
    })
  );

  dispatch(dispararTempoExpiracao(dadosAcesso.dataExpiracao, idSessao, dadosAcesso.tokenJwt));

  if (empresaSelecionada.id === HELP_MYPARDINI.ID) {
    window.location.href = `/interno/busca/${ORIGENS_INTEGRACAO.MYPARDINI.apelidoUrl}`;
  } else {
    window.location.href = `/interno/busca/${empresaSelecionada.apelidoUrl}`;
  }
};

const renovarDadosUsuario = (dadosAcesso, idSessao, dispatch) => {
  dispatch(
    loginActions.renovarDadosAcesso({
      ...dadosAcesso.usuario,
      expiracaoTokenEmMinutos: dadosAcesso.expiracaoTokenEmMinutos,
      administrador: dadosAcesso.administrador,
      perfilUsuario: dadosAcesso.perfilUsuario
    })
  );
  dispatch(dispararTempoExpiracao(dadosAcesso.dataExpiracao, idSessao, dadosAcesso.tokenJwt));
};

export const inserirDadosAcesso = (idSessao, origemToken) => async dispatch => {
  if (!idSessao) {
    limparDadosAcessoEStorage(dispatch);
    return;
  }

  try {
    const resposta = await AutenticacaoService.autenticarUsuario(idSessao, origemToken);
    if (resposta && resposta.data) {
      inserirDadosUsuario(resposta.data, resposta.data.idSessao, dispatch);
    } else {
      limparDadosAcessoEStorage(dispatch);
    }
  } catch (error) {
    limparDadosAcessoEStorage(dispatch);
  }
};

export const validarToken = () => async dispatch => {
  try {
    const resposta = await AutenticacaoService.validarToken();
    if (resposta && resposta.data) {
      inserirDadosUsuario(resposta.data, resposta.data.idSessao, dispatch);
    } else {
      limparDadosAcessoEStorage(dispatch);
    }
  } catch (error) {
    limparDadosAcessoEStorage(dispatch);
  }
};

export const renovarToken = () => async dispatch => {
  try {
    const resposta = await AutenticacaoService.renovarToken();
    if (resposta && resposta.data) {
      renovarDadosUsuario(resposta.data, resposta.data.idSessao, dispatch);
    } else {
      limparDadosAcessoEStorage(dispatch);
    }
  } catch (error) {
    limparDadosAcessoEStorage(dispatch);
  }
};

export const trocarEmpresa = (siglaUsuario, idEmpresa) => async dispatch => {
  try {
    const resposta = await AutenticacaoService.trocarEmpresa(siglaUsuario, idEmpresa);

    if (resposta && resposta.data) {
      const empresa =
        idEmpresa !== HELP_MYPARDINI.ID
          ? await EmpresaService.obterDadosEmpresa("", idEmpresa).then(
              retorno => retorno && retorno.data
            )
          : { id: idEmpresa };
      trocarEmpresaUsuario(resposta.data, resposta.data.idSessao, empresa, dispatch);
    } else {
      limparDadosAcessoEStorage(dispatch);
    }
  } catch (error) {
    limparDadosAcessoEStorage(dispatch);
  }
};

export const atualizarTempoExpiracaoToken = minutos => dispatch => {
  dispatch(loginActions.atualizarTempoExpiracaoToken(minutos));
};

export const dispararTempoExpiracao = (dataExpiracao, idSessao, tokenJwt) => async dispatch => {
  if (!dataExpiracao) loginActions.limparDadosAcesso();

  const dataAgora = new Date();
  localStorage.setItem(chaveArmazenamentoIdSessao, idSessao);
  localStorage.setItem(chaveArmazenamentoToken, tokenJwt);

  let periodoEmSegundos = 1;

  if (moment(dataExpiracao).isAfter(dataAgora)) {
    periodoEmSegundos = moment
      .duration(
        moment(dataExpiracao, "YYYY/MM/DD HH:mm").diff(moment(dataAgora, "YYYY/MM/DD HH:mm"))
      )
      .asSeconds();
  }

  clearTimeout(ultimoTimeout);

  ultimoTimeout = setTimeout(() => {
    limparDadosAcessoEStorage(dispatch);
  }, periodoEmSegundos * 1000);
};
